import { useReducer, useEffect } from 'react';
import { QUERY_STATE } from '../constants';
const initialFetchState = {
    queryState: QUERY_STATE.EMPTY,
    data: null,
    error: null,
    response: null,
};
const useFetchReducer = (state, action) => {
    switch (action.type) {
        case 'START':
            return { ...state, queryState: QUERY_STATE.WAITING, data: null };
        case 'SUCCESS':
            return { ...state, ...action.payload, queryState: QUERY_STATE.SUCCESS };
        case 'FAIL':
            return { ...state, ...action.payload, queryState: QUERY_STATE.FAIL };
        case 'ABORT':
            return { ...state, ...action.payload, queryState: QUERY_STATE.EMPTY };
        default:
            return state;
    }
};
export function useFetch(url, method = 'GET', body, headers, responseType = 'json') {
    const [fetchState, dispatchFetchAction] = useReducer((useFetchReducer), initialFetchState);
    const serializedBody = body ? JSON.stringify(body) : null;
    const serializedHeaders = headers ? JSON.stringify(headers) : null;
    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        const fetchData = async () => {
            if (!url) {
                dispatchFetchAction({
                    type: 'ABORT',
                    payload: { error: null, response: null, data: null },
                });
                return;
            }
            dispatchFetchAction({ type: 'START' });
            let response = null;
            try {
                response = await fetch(url, { method, body, headers, signal });
                if (response.ok) {
                    let data;
                    switch (responseType) {
                        case 'blob':
                            data = await response.blob();
                            break;
                        case 'text':
                            data = await response.text();
                            break;
                        case 'arrayBuffer':
                            data = await response.arrayBuffer();
                            break;
                        case 'formData':
                            data = await response.formData();
                            break;
                        case 'json':
                        default:
                            data = await response.json();
                            break;
                    }
                    dispatchFetchAction({ type: 'SUCCESS', payload: { data, response } });
                }
                else {
                    dispatchFetchAction({
                        type: 'FAIL',
                        payload: {
                            error: new Error(`Cannot get data: ${response.statusText}`),
                            response,
                        },
                    });
                }
            }
            catch (error) {
                const name = error instanceof Error ? error.name : undefined;
                dispatchFetchAction({
                    type: name === 'AbortError' ? 'ABORT' : 'FAIL',
                    payload: { error, response },
                });
            }
        };
        fetchData();
        return () => {
            controller.abort();
        };
    }, [url, method, responseType, serializedBody, serializedHeaders]);
    return fetchState;
}
//# sourceMappingURL=useFetch.js.map